import { type PropsWithChildren } from 'react';
import { classNames } from '@vkontakte/vkui';
import styles from './NativeGlassCard.module.css';

interface NativeGlassCardProps extends PropsWithChildren {
  className?: string;
}

export function NativeGlassCard(props: NativeGlassCardProps) {
  const { children, className } = props;

  return <div className={classNames(styles.root, className)}>{children}</div>;
}
